module.exports = __webpack_public_path__ + "static/img/dingdan.2cd1933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/dingdan.png
// module id = U7gn
// module chunks = 19